import script from "./TheNavbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheNavbar.vue?vue&type=script&lang=ts&setup=true"

import "./TheNavbar.vue?vue&type=style&index=0&id=fa036fe4&lang=scss&scoped=true"
script.__scopeId = "data-v-fa036fe4"

export default script